export const inviteFriend = {
  inviteFriendEmail: "Correo",
  inviteFriendEmailError: "No es un correo válido!",
  inviteFriendDate: "Fecha",
  inviteFriendButton: "Invitar",
  inviteFriendRegistered: "Amigos registrados.",
  inviteFriendLoadingList: "Cargando lista de invitados...",
  inviteFriendNoReferrals: "No tienes amigos registrados.",
  inviteFriendToSeeThemHere: "Invita amigos para verlos aquí",
};
